/**
 * @author Kelnik
 *
 * InputFile - инпут с файлом
 */

import Utils from 'common/scripts/utils';

class InputFile {
    constructor(options) {
        this.container = options.container;

        this.defLabel = '';
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._saveDefLabel();
        this._bindEvents();
    }

    _initElements() {
        this.input = this.container.querySelector('.j-input-file-input');
        this.remove = this.container.querySelector('.j-input-file-name');
        this.name = this.container.querySelector('.j-input-file-name');
    }

    _saveDefLabel() {
        this.defLabel = this.name.innerHTML;
    }

    _bindEvents() {
        this.input.addEventListener('change', (event) => {
            if (event.target.value) {
                const name = event.target.value.split('\\').pop();

                this._setName(name);
            } else {
                this._setName();
            }
        });
    }

    _setName(name) {
        if (!this.name) {
            return;
        }

        Utils.clearHtml(this.name);
        Utils.insetContent(this.name, `${name || this.defLabel}`);
    }
}

export default InputFile;
